import includes from 'lodash/includes';

export function getWidgetKey(widgetData) {
  // Custom and Reading List widgets have unique IDs
  if(widgetData.type === 'custom' || includes(widgetData.type, 'ReadingListsWidget')) {
    return widgetData.id;
  }

  // Standard widgets don't have unique IDs, but helpfully, they can't have
  // duplicate types either.
  return widgetData.type;
}
